import React from 'react';
import { Card, CardContent, Typography, Box, useTheme, alpha } from '@mui/material';

interface StatCardProps {
    title: string;
    value: string | number;
    icon: React.ReactNode;
    color: string;
    tooltip?: string;
}

const StatCard: React.FC<StatCardProps> = ({ title, value, icon, color }) => {
    const theme = useTheme();

    return (
        <Card
            sx={{
                height: '100%',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: theme.palette.mode === 'light'
                        ? '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)'
                        : '0 10px 15px -3px rgb(0 0 0 / 0.3), 0 4px 6px -4px rgb(0 0 0 / 0.3)',
                },
                transition: 'all 0.3s ease-in-out',
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 48,
                            height: 48,
                            borderRadius: 3,
                            backgroundColor: alpha(color, 0.1),
                            color: color,
                        }}
                    >
                        {icon}
                    </Box>
                </Box>
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ fontWeight: 600, mb: 0.5, textTransform: 'uppercase', letterSpacing: 0.5, fontSize: '0.75rem' }}
                >
                    {title}
                </Typography>
                <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.primary' }}>
                    {value}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default StatCard;
